import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type SearchState } from './searchTypes';
import { getInitialSessionOnClientEntry } from '../../helpers/sessionHelper';
import { replaceSpaceChar } from '../../helpers/formHelper';

const initialState = (): SearchState => {
  const restoredState = getInitialSessionOnClientEntry();
  return {
    ...restoredState.search,
  };
};

const searchSlice = createSlice({
  name: 'search',
  initialState: initialState(),
  reducers: {
    updatePostCodeInSearch: (state, action: PayloadAction<string>) => {
      state.postCode = CSS_CONFIG.formats.useZipCodeSpaceTrim
        ? replaceSpaceChar(action.payload.toUpperCase())
        : action.payload.toUpperCase().trim();
    },
    updateCountryStateInSearch: (state, action: PayloadAction<string>) => {
      state.state = action.payload;
    },
    updateAddressInSearch: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },
    updateCityInSearch: (state, action: PayloadAction<string>) => {
      state.city = action.payload;
    },
    resetSearchSessionState: (state) => {
      state.postCode = '';
      state.city = '';
      state.address = '';
      state.state = '';
    },
  },
});

export const {
  updatePostCodeInSearch,
  updateCountryStateInSearch,
  updateAddressInSearch,
  updateCityInSearch,
  resetSearchSessionState,
} = searchSlice.actions;

export default searchSlice.reducer;
